import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M9.02896 1.39667C8.61475 0.534445 7.38433 0.534443 6.97012 1.39667L5.19854 5.08446L1.118 5.61875C0.171979 5.74262 -0.221931 6.91157 0.482441 7.57574L3.46437 10.3875L2.71602 14.4019C2.53834 15.355 3.54737 16.0615 4.381 15.6121L7.99954 13.6613L11.6181 15.6121C12.4517 16.0615 13.4607 15.355 13.2831 14.4019L12.5347 10.3875L15.5166 7.57574C16.221 6.91157 15.8271 5.74262 14.8811 5.61875L10.8005 5.08446L9.02896 1.39667Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }